import { Box, Grid, ImageList, ImageListItem, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useEffect, useState } from 'react'
import { useNavigate } from "react-router-dom";

import { MoreInfoButtonStyle } from "./styled";

import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import React from "react";


const itemData = [
    {
        width: 432,
        height: 231,
        rows: 18,
        widthT: 364,
        heightT: 283,
        rowsT: 21,
        widthP: 350,
        heightP: 272,
        rowsP: 20
    },
    {
        width: 438,
        height: 315,
        rows: 24,
        widthT: 364,
        heightT: 477,
        rowsT: 35,
        widthP: 350,
        heightP: 460,
        rowsP: 34
    },
    {
        width: 409,
        height: 654,
        rows: 47,
        widthT: 364,
        heightT: 179,
        rowsT: 14,
        widthP: 350,
        heightP: 172,
        rowsP: 13
    },
    {
        width: 432,
        height: 403,
        rows: 29,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 350,
        heightP: 252,
        rowsP: 19
    },
    {
        width: 438,
        height: 320,
        rows: 23,
        widthT: 364,
        heightT: 262,
        rowsT: 20,
        widthP: 350,
        heightP: 252,
        rowsP: 19
    },

    {
        width: 432,
        height: 654,
        rows: 47,
        widthT: 0,
        heightT: 0,
        rowsT: 0,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 438,
        height: 403,
        rows: 30,
        widthT: 0,
        heightT: 0,
        rowsT: 0,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 409,
        height: 315,
        rows: 24,
        widthT: 0,
        heightT: 0,
        rowsT: 0,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 409,
        height: 320,
        rows: 23,
        widthT: 0,
        heightT: 0,
        rowsT: 0,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    },
    {
        width: 438,
        height: 231,
        rows: 18,
        widthT: 0,
        heightT: 0,
        rowsT: 0,
        widthP: 0,
        heightP: 0,
        rowsP: 0
    }
];



const Reporting = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const { SearchReportingImage } = useActions();
    const { reportingImages, count } = useTypedSelector((store) => store.reportingImage);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        try {
            await SearchReportingImage(1, 5);
        } catch (ex) {
        }
    };

    return (
        <>
            <Grid item xs={4} md={5} lg={12} sx={{ mt: { xs: "43px", lg: "120px" } }}>
                <Typography variant="h2" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", md: "24px", lg: "36px" }} lineHeight="38px">
                    Наша звітність
                </Typography>
                {(isXl || isLg) && <ImageList
                    variant="quilted"
                    cols={3}
                    rowHeight={10}
                    sx={{ display: { xs: "none", lg: "grid" }, mt: "34px", overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            {index < 5 && <ImageListItem rows={itemData[index].rows || 1} sx={{ mr: "8px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    style={{ width: `${itemData[index].width}px`, height: `${itemData[index].height}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>}
                        </React.Fragment>
                    ))}
                </ImageList>}
                {isMd && <ImageList
                    variant="quilted"
                    cols={isXs ? 1 : 2}
                    rowHeight={10}
                    sx={{ display: { xs: "grid", lg: "none" }, mt: "14px", overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            {index < 5 && <ImageListItem rows={itemData[index].rowsT || 1} sx={{ mr: "8px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    style={{ width: `${itemData[index].widthT}px`, height: `${itemData[index].heightT}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>}
                        </React.Fragment>
                    ))}
                </ImageList>}
                {isXs && <ImageList
                    variant="quilted"
                    cols={1}
                    rowHeight={10}
                    sx={{ display: { xs: "grid", md: "none" }, mt: "14px", overflowY: "unset" }}
                >
                    {reportingImages.map((item, index) => (
                        <React.Fragment key={`reporting_image_${index}`}>
                            {index < 5 && <ImageListItem rows={itemData[index].rowsP || 1} sx={{ mr: "8px" }}>
                                <img
                                    loading="lazy"
                                    src={item.name}
                                    style={{ width: `${itemData[index].widthP}px`, height: `${itemData[index].heightP}px`, borderRadius: "8px" }}
                                    alt={`reporting_image_${index}`}
                                />
                            </ImageListItem>}
                        </React.Fragment>
                    ))}
                </ImageList>}
                <Box sx={{ display: "flex", justifyContent: "center", mt: { xs: "38px", md: "16px", lg: "32px" } }}>
                    <MoreInfoButtonStyle onClick={() => { navigate("/how-is-event-going"); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                        Дізнатися більше
                    </MoreInfoButtonStyle>
                </Box>
            </Grid >
        </>
    )
}

export default Reporting